import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Tool, Company } from 'toolbandi-ui-lib';
import { Search, SharedDataService, CrudService, MessageService } from 'elbuild-ui-lib-core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-tool-edit',
	templateUrl: './tool-edit.component.html',
	styleUrls: ['./tool-edit.component.scss']
})
export class ToolEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	tool: Tool;
	tab: string;
	editable: string;

	@Input()
	companyid: number;

	search: {
		company: Search
	};
	selected: {
		company: Company
	};

	title: string;

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private toolService: CrudService<Tool>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private companyService: CrudService<Company>,
		private activeModal: NgbActiveModal
	) {

		this.search = {
			company: new Search('company')
		};

		this.selected = {
			company: undefined
		};
	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.tool = new Tool();
				this.title = 'tool-create';
				if (this.companyid) {
					this.tool.companyid = this.companyid;
					this.findCompany(this.tool.companyid);
				}

				this.loading = false;
			}
		});
	}

	load(id: number): void {
		this.loading = true;
		this.toolService.getEntity(Tool, 'tool', id).subscribe(tool => {
			this.tool = tool;
			this.title = 'tool-edit';
			this.loading = false;
			this.initItem();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.tool'));
			this.tool = undefined;
			this.loading = false;
		});

	}

	findCompany(cid: number): void {
		if (cid) {
			this.companyService.getEntity(Company, 'company', cid).subscribe((c: Company) => {
				this.selected.company = c;
			});
		}
	}

	initItem(): void {
		this.findCompany(this.tool.companyid);
	}

	setSelectedFields(): void {
		this.tool.companyid = this.selected.company.id;
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	submit(): void {
		this.setSelectedFields();
		if (!this.tool.id) {
			this.toolService.createEntity(Tool, 'tool', this.tool).subscribe(response => {
				this.tool = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.tool-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.tool);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.toolService.saveEntity(Tool, 'tool', this.tool).subscribe(response => {
				this.tool = response;
				this.initItem();
				this.messageService.sendSuccess(
					this.translateService.instant('labels.tool-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.tool);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

}
